/* eslint-disable class-methods-use-this */
import { demeterDownloadsApi } from '../../../Apis/Apis';
import ContentTypes from '../../../Core/Common/ContentTypes';
import { DataSeries } from '../../../Generated/Raven-Demeter';
import browserService from '../BrowserService';

class DownloadService {
    downloadCsv = (rawDownloadData: DataSeries[], title: string) => {
        (async () => {
            const structuredCsvData = await demeterDownloadsApi.downloadData(
                {
                    dataSeries: rawDownloadData,
                },
                {
                    headers: {
                        accept: 'text/csv',
                    },
                },
            );
            browserService.downloadCsv(structuredCsvData.data as string, title);
        })();
    };

    downloadXlsx = (rawDownloadData: DataSeries[], title: string) => {
        (async () => {
            const xlsxFileStream = await demeterDownloadsApi.downloadExcel(
                {
                    dataSeries: rawDownloadData,
                },
                {
                    headers: {
                        accept: ContentTypes.Excel,
                    },
                    responseType: 'blob',
                },
            );
            browserService.downloadBlob(xlsxFileStream.data as unknown as Blob, `${title}.xlsx`);
        })();
    };
}

const downloadService = new DownloadService();

export default downloadService;
